import { useController, useFormContext } from 'react-hook-form';

import { css } from '@flipster/styled-system/css';
import { center } from '@flipster/styled-system/patterns';
import { NumberInput } from '@flipster/ui';
import { inputFormatter } from '@flipster/utils/num';

interface Props {
  name: string;
  currency: string;
  currencyClassName?: string;
  precision: number;
  max?: string;
  placeholder?: string;
}

const SendPriceInput = ({ name, precision, currency, currencyClassName, max, placeholder = '0' }: Props) => {
  const { control, trigger } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name, control });

  const handleChange = (newValue: string) => {
    onChange(newValue);
    trigger(name);
  };

  return (
    <div className={css({ position: 'relative', width: '100%' })}>
      <NumberInput
        shape='inner'
        size='large'
        value={value}
        onChange={handleChange}
        currency={currency}
        precision={precision}
        className={customInputStyle}
        max={max}
        onBlur={() => {
          trigger(name);
        }}
      />
      <div className={fakeInputStyle}>
        {(!value || value === '0') && placeholder ? placeholder : inputFormatter(value, { withComma: true })}
        <span className={currencyClassName}>{currency}</span>
      </div>
    </div>
  );
};

export default SendPriceInput;

const customInputStyle = css({
  color: 'transparent',

  '& > input': {
    pl: 4,
    textStyle: 'Title/M!',
    fontFeatureSettings: 'normal!',
    fontVariantNumeric: 'normal!',
    zIndex: 1,
    textAlign: 'center',
    caretColor: 'content.accent.info',
  },

  '& > span': {
    textStyle: 'Title/M!',
  },
});

const fakeInputStyle = center({
  position: 'absolute',
  left: -12,
  right: 0,
  top: 0,
  bottom: 0,
  color: 'content.default.level-4',

  '& > span': {
    pl: 4,
  },
});
